import { fetchLocalFiles } from './fetchLocalFilesThunk';
export default fetchLocalFiles;
